<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="preview">
  <div class="preview__area" *ngIf="previewContent">
    <ng-container *ngFor="let contentItem of previewContent; trackBy: trackByFn; let i = index">
      <div
        class="image-collage"
        *ngIf="
          shouldShowCollage() && isContentImagePreview(contentItem) && !isContentDownloadCard(contentItem) && i === getFirstImageIndex()
        "
      >
        <div class="collage-grid" [ngClass]="getCollageClass()">
          <div class="collage-item" *ngFor="let imageContent of getDisplayedImages(); trackBy: trackByFn; let j = index">
            <ptl-resource-image-preview
              [content]="imageContent"
              [class.collage-image]="true"
              [collage]="collage"
            ></ptl-resource-image-preview>
          </div>

          <div class="collage-item more-images" *ngIf="getRemainingCount() > 0">+{{ getRemainingCount() }}</div>
        </div>
      </div>

      <ng-container *ngIf="!shouldShowCollage() || !isContentImagePreview(contentItem) || isContentDownloadCard(contentItem)">
        <ptl-file-download-card
          data-testid="preview-download-card"
          *ngIf="isContentDownloadCard(contentItem)"
          [class.first-preview]="i === 0"
          [url]="getDownloadCardUrl(contentItem)"
          [fileName]="getDownloadCardFileName(contentItem)"
          [caption]="getDownloadCardCaption(contentItem)"
        >
        </ptl-file-download-card>

        <ptl-resource-html-preview
          data-testid="preview-html"
          [attr.data-block-type]="contentItem.type"
          *ngIf="isContentHtmlPreview(contentItem)"
          [class.first-html-preview]="i === 0"
          [content]="contentItem"
          [withTruncateLines]="withTruncateLines"
        >
        </ptl-resource-html-preview>

        <ptl-resource-form-preview
          *ngIf="contentItem.type === 'FORM'"
          [formContent]="contentItem"
          [isCollectorTemplateForm]="isCollectorTemplateForm"
          [canEditCollectorTemplateForm]="canEditCollectorTemplateForm"
          [userPlaylistSubmissionSummary]="userPlaylistSubmissionSummary"
          [userPlaylistAllMentorsFeedback]="userPlaylistAllMentorsFeedback"
          [hideTextFormButtons]="hideTextFormButtons"
        ></ptl-resource-form-preview>

        <ptl-resource-image-preview
          data-testid="preview-image"
          *ngIf="isContentImagePreview(contentItem) && !isContentDownloadCard(contentItem)"
          [class.first-preview]="i === 0"
          [content]="contentItem"
        >
        </ptl-resource-image-preview>

        <ptl-resource-stream-video-preview
          data-testid="preview-stream-video"
          *ngIf="isContentStreamVideoPreview(contentItem)"
          [class.first-preview]="i === 0"
          [content]="contentItem"
          [disableFunctions]="folioAttachmentPreviewView"
          [folioAttachmentPreviewView]="folioAttachmentPreviewView"
        >
        </ptl-resource-stream-video-preview>

        <ptl-resource-video-preview *ngIf="isContentVideoPreview(contentItem)" [class.first-preview]="i === 0" [content]="contentItem">
        </ptl-resource-video-preview>

        <ptl-resource-document-preview
          data-testid="preview-document"
          *ngIf="isContentDocumentPreview(contentItem) && !isContentDownloadCard(contentItem)"
          [class.first-preview]="i === 0"
          [content]="contentItem"
          [isEditingContent]="folioAttachmentPreviewView"
        >
        </ptl-resource-document-preview>

        <ptl-v3-resource-audio-preview
          data-testid="preview-audio"
          *ngIf="isContentAudioPreview(contentItem) && !isContentDownloadCard(contentItem) && isV3Enabled"
          [class.first-preview]="i === 0"
          [content]="contentItem"
        >
        </ptl-v3-resource-audio-preview>

        <ptl-resource-audio-preview
          data-testid="preview-audio"
          *ngIf="isContentAudioPreview(contentItem) && !isContentDownloadCard(contentItem) && !isV3Enabled"
          [class.first-preview]="i === 0"
          [content]="contentItem"
        >
        </ptl-resource-audio-preview>

        <ptl-external-preview
          data-testid="preview-link"
          *ngIf="contentItem.type === 'EXTERNAL_CONTENT_SUMMARY'"
          [content]="contentItem"
          [folioAttachmentPreviewView]="folioAttachmentPreviewView"
        >
        </ptl-external-preview>

        <ptl-chart-preview
          *ngIf="contentItem.type === 'CHART'"
          [chartContent]="contentItem"
          [includeSelfFeedback]="includeSelfFeedback"
          [learner]="learner"
        >
        </ptl-chart-preview>

        <ptl-pi-trait-chart *ngIf="contentItem.type === 'TRAITS_CHART'" [content]="contentItem"> </ptl-pi-trait-chart>

        <ptl-pi-team-role-chart *ngIf="contentItem.type === 'TEAM_ROLES_CHART'" [content]="contentItem"> </ptl-pi-team-role-chart>

        <ptl-pi-big-six-chart *ngIf="contentItem.type === 'BIG_SIX_CHART'" [content]="contentItem"> </ptl-pi-big-six-chart>

        <ptl-pi-jungian-chart *ngIf="contentItem.type === 'JUNGIAN_TYPES_CHART'" [content]="contentItem"> </ptl-pi-jungian-chart>

        <ptl-pi-spectrum-chart *ngIf="contentItem.type === 'SPECTRUM_CHART'" [showStaticData]="true" [content]="contentItem">
        </ptl-pi-spectrum-chart>

        <div
          *ngIf="
            contentItem.type === 'EXTERNAL_CONTENT_SUMMARY' ||
            isContentDocumentPreview(contentItem) ||
            isContentAudioPreview(contentItem) ||
            isContentVideoPreview(contentItem) ||
            isContentDownloadCard(contentItem)
          "
          class="print-content"
        >
          <a [href]="getUrl(contentItem)" target="_blank">{{ getText(contentItem) }}</a>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
